import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { OrderByDirection } from 'types/types';

interface OrderButtonProps {
  orderDirection: OrderByDirection;
  orderBy: string;
  onClick: () => void;
}

export function OrderButton({ orderDirection, onClick }: OrderButtonProps) {
  return (
    <IconButton size="small" onClick={onClick}>
      {orderDirection === OrderByDirection.asc ? (
        <ArrowUpward fontSize="small" />
      ) : (
        <ArrowDownward fontSize="small" />
      )}
    </IconButton>
  );
}
